// ═══════════════════════════════════════════════════════════════════════
// BELLANOR AP — Cliente Supabase
// ═══════════════════════════════════════════════════════════════════════
//
// Variáveis de ambiente (Create React App):
//   REACT_APP_SUPABASE_URL  → URL do projeto Supabase
//   REACT_APP_SUPABASE_KEY  → anon key (pública, protegida por RLS)
//
// Fallback hardcoded para o projeto Bellanor (remove em produção se preferir)
// ═══════════════════════════════════════════════════════════════════════

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://nmmpexnslmlhrozqiidf.supabase.co";

const SUPABASE_KEY =
  process.env.REACT_APP_SUPABASE_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5tbXBleG5zbG1saHJvenFpaWRmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgwMjkyMjksImV4cCI6MjA5MzYwNTIyOX0.yDzXh2oZG_29PMwU7OH26anBhVPWBCUOjSJGr1C1bZs";

export const supabase = SUPABASE_KEY
  ? createClient(SUPABASE_URL, SUPABASE_KEY)
  : null;

// Flag pra saber se o Supabase tá configurado
export const isSupabaseReady = !!supabase;
